/* HX — swatche wariantów w kartach produktów.
   Klik w miniaturę koloru podmienia główne zdjęcie karty na zdjęcie wariantu.
   Delegacja na dokumencie — działa też dla kart doładowanych później (paginacja/filtry). */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.hx-sw__btn');
    if (!btn) return;

    // Karta produktu to zwykle <a> — nie nawiguj, tylko podmień zdjęcie.
    e.preventDefault();
    e.stopPropagation();

    var sw = btn.closest('[data-hx-sw]');
    if (!sw) return;
    var wrap = sw.parentElement;
    if (!wrap) return;

    // Główne zdjęcie = bezpośredni <img> media-wrappera (miniatury swatchy są zagnieżdżone głębiej).
    var main = wrap.querySelector(':scope > img');
    if (main) {
      var src = btn.getAttribute('data-hx-sw-img');
      if (src) {
        main.removeAttribute('srcset'); // żeby srcset nie nadpisało nowego src
        main.src = src;
      }
    }

    var all = sw.querySelectorAll('.hx-sw__btn');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('is-active');
    btn.classList.add('is-active');
  }, false);
})();
